import { EgretLoadable } from "egret";
// import { isMobile } from "utils";
// import { isMdScreen } from "utils";
 
const SignUp = EgretLoadable({
  loader: () => import("./SignUp")
});

const SignIn = EgretLoadable({
  loader: () => import("./SignIn")
});

const NotFound = EgretLoadable({
  loader: () => import("./NotFound")
});


const ForgotPassword = EgretLoadable({
  loader: () => import("./ForgotPassword")
});

const AdminLogout = EgretLoadable({
  loader: () => import("./AdminLogout")
});

const DarkMode = EgretLoadable({
  loader: () => import("./DarkMode")
});


const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: "close"
    }
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

// if (isMobile() && isMdScreen()) {
//   settings.layout1Settings.leftSidebar = {
//     show: false,
//     mode: "close"
//   };
// }

const adminLoginRoutes = [ 
  {
    path: "/selectmode",
    component: DarkMode,
    settings
  },
  {
    path: "/agentlogin",
    component: SignIn,
    settings
  },
  {
    path: "/agentLogout",
    component: AdminLogout,
    settings
    },
    {
        path: "/adminForgotPassword",
        component: ForgotPassword,
        settings
    },
  {
    path: "/admin-login/404",
    component: NotFound,
    settings
  },
  {
    path: "/userSignUp",
    component: SignUp,
    settings
  },
];

export default adminLoginRoutes;
